import React from 'react';
import Link from '@anwb/link';
import { ELEMENT_TYPES } from '../../helpers/ElementTypes';
import { PanelLink, PanelLinkIcon, PanelLinksContainer } from './styles';
/**
 * The panel links is used to display a list of links in a panel
 */
const PanelLinks = ({ links, numbered = false, dataTest = 'panel-links' }) => {
    if (!links || links.length === 0)
        return null;
    return (React.createElement(PanelLinksContainer, { "data-test": `${dataTest}-links`, as: numbered ? 'ol' : 'ul' }, links.map(({ href, text, dataProperties, disableIcon, icon: linkIcon, onClickFn, sub }, index) => (React.createElement(PanelLink, { key: `${href || ''}-${text}`, "$numbered": numbered },
        React.createElement(Link, Object.assign({ dataTest: `${dataTest}-link-${index}`, disableIcon: disableIcon, href: href, onClick: onClickFn, sub: sub }, dataProperties),
            linkIcon && (React.createElement(PanelLinkIcon, { "data-test": `${dataTest}-link-icon`, size: linkIcon.size, type: linkIcon.type, variant: linkIcon.icon })),
            text))))));
};
PanelLinks.PANEL_ELEMENT = ELEMENT_TYPES.LINKS;
export { PanelLinks };
//# sourceMappingURL=PanelLinks.js.map